import { useEffect } from "react";
import { io } from "socket.io-client";

const API_URL = process.env.REACT_APP_API_URL;

export const socket = io(API_URL);

export function useJoinRoom(roomId?: string) {
    useEffect(() => {
        if (!roomId) return;

        // IMPORTANT: undo a prior disconnectSocket() that disabled reconnection
        socket.io.opts.reconnection = true;

        // make sure we actually connect (emit will not magically connect if you've disconnected)
        if (!socket.connected) socket.connect();

        const payload = { roomId };

        const join = () => {
            socket.emit("room:join", payload);
        };

        // join now and on every connect (includes reconnects)
        join();
        socket.on("connect", join);

        return () => {
            socket.off("connect", join);
            socket.emit("room:leave", payload, () => { });
        };
    }, [roomId]);
}


export function useJoinSnippetRoom(roomId?: string, snippetId?: string) {
    useEffect(() => {
        if (!roomId || !snippetId) return;

        const payload = { roomId, snippetId };

        // join current snippet room
        socket.emit("snippet:join", payload);

        // re-join after reconnect (rooms are lost on reconnect)
        const rejoin = () => socket.emit("snippet:join", payload);
        socket.on("connect", rejoin);
        socket.on("reconnect", rejoin);

        // cleanup runs when snippetId/roomId change or component unmounts:
        // leaves the *previous* snippet room
        return () => {
            socket.off("connect", rejoin);
            socket.off("reconnect", rejoin);
            socket.emit("snippet:leave", payload);
        };
    }, [roomId, snippetId]);
}



export function disconnectSocket(reason?: string) {
    // prevent auto-reconnect loops (optional but usually what you want for "idle disconnect")
    socket.io.opts.reconnection = false;

    // close connection (server will auto-remove this socket from all rooms)
    socket.disconnect();
}



export function reconnectSocket(reason?: string) {
    socket.io.opts.reconnection = true;

    if (!socket.connected) {
        socket.connect();
    }
}


